import React, {useEffect, useCallback, useState} from 'react';
import { getJudgeName } from "../../utils";

const Phase4 = (props) => {
  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetPhase = props.handleSetPhase
  const handleSetStale = props.handleSetStale
  const handleUpdatePhotoCard = props.handleUpdatePhotoCard
  const handleCaptionCreate = props.handleCaptionCreate
  const handleSetCaptionInput = props.handleSetCaptionInput
  const handleSetParticipantName = props.handleSetParticipantName

  const [error, setError] = useState('');
  const [captionSubmitted, setCaptionSubmitted] = useState(false);
  const [countdownSecond, setCountdownSecond] = useState(180);

  const getPhotoCard = (photoCardId) => {
    for (let i = 0; i < props.photoCards.length; i++) {
      if (props.photoCards[i]["$id"] === photoCardId) {
        return props.photoCards[i]
      }
    }
  }

  const getWaitingOnTeams = useCallback(() => {
    return (
      <div className="text-gray-950 text-md mx-auto">
        <span className="">Still waiting for captions from <span className="text-xl font-bold">{props.gameParticipants.length - props.captions.length}</span> {(props.gameParticipants.length - props.captions.length) > 1 ? "teams" : "team"}</span>
      </div>
    )
  }, [props.captions, props.gameParticipants]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCountdownSecond(countdownSecond - 1);
      if (props.captions.length >= props.gameParticipants.length || countdownSecond <= 1) {
        handleGameStateChanged({newPhase: 5})
        clearTimeout(timer)
      }
    }, 1000);
  }, [props.captions, props.gameParticipants, countdownSecond]);

  useEffect(() => {
    const playerTimer = setTimeout(() => {
      if (props.playerCaption?.Caption === "" || props.playerCaption?.Caption === undefined || props.playerCaption?.Caption === null) {
        handleSetStale();
        return
      }
      clearTimeout(playerTimer)
    }, 3000);
  }, [props.playerCaption]);

  const loadPhotoCard = useCallback(() => {
    return (
      <div className="box relative w-[75%] h-auto bg-[#020223] border border-[15px] border-gray-400 rounded-2xl">
        <img src={getPhotoCard(props.gameState.PhotoCardID)?.ImageUrl} />
      </div>
    )
  }, [props.gameState.PhotoCardID]);

  const loadTeamCaptions = useCallback(() => {
    return (
      <div className="grid grid-cols items-center justify-center">
        {props.captions.map((caption, _) => {
          return (
            <div
              key={caption.$id}
              className="w-[300px] mx-[5%] grid place-items-center"
            >
              <img
                className="w-[300px] grayscale hover:grayscale-0 transition duration-500 ease-in-out"
                src="https://johnsonfamreunion.s3.us-west-2.amazonaws.com/Memes/stock/Hand-drawn-empty-speech-bubble-comic-on-transparent-background-PNG.png"
              />
              <div className="relative top-[-180px] transform text-gray-800 text-xl font-bold">{caption.ParticipantName}</div>
            </div>
          )
        }) }
      </div>
    )
  }, [props.captions]);

  const loadCaptionMetaSection = useCallback(() => {
    return (
      <div className="mt-[8px]">
        {captionSubmitted || props.playerCaption?.Caption !== "" ?
          getWaitingOnTeams()
          : (
            <h3 className="text-gray-950 text-lg"><span className="font-bold">{props.participantName || localStorage.getItem('participantName')}</span> - enter your caption below</h3>
          )}
      </div>
    )
  }, [
    captionSubmitted,
    props.participantName,
    props.playerCaption,
    getWaitingOnTeams,
  ]);

  const loadCaptionSection = useCallback(() => {
    console.log("loadCaptionSection", props.playerCaption)
    if (captionSubmitted || (props.playerCaption?.Caption !== "" && props.playerCaption?.Caption !== undefined && props.playerCaption?.Caption !== null)) {
      return (
        <div className="mt-4">
          <div className="text-xl text-red-900">{error}</div>
          <div className="flex justify-center items-center">
            <div
              className="box relative w-[75%] h-auto bg-[#020223] border-[15px] border-gray-400 rounded-2xl">
              <img src={getPhotoCard(props.gameState.PhotoCardID)?.ImageUrl}/>
            </div>
          </div>

          <div className="mt-4 place-items-center">
            {loadTeamCaptions()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="mt-4">
          <div className="text-xl text-red-900">{error}</div>
          <form onSubmit={handleSubmit}>
            <div className="flex justify-center items-center">
              {loadPhotoCard()}
            </div>

            <div className="mx-[10%]">
              <label className="block mt-2 font-bold text-xl"> Your Caption</label>
              <textarea
                className="p-1 mt-1 w-full placeholder-gray-400 text-gray-700 bg-white text-lg border border-1 border-b-2 border-gray-600 focus:ring-0 focus:border-gray-900 rounded-lg focus:shadow-xl"
                type="text"
                disabled={getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants) ===
                  localStorage.getItem('participantName')}
                placeholder={"Enter your caption"}
                onChange={(e) => handleSetCaptionInput(e.target.value)}
              />

              <div className="mb-6 flex w-full content-center items-center">
                <button
                  type="submit"
                  disabled={!props.captionInput || getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants) ===
                    localStorage.getItem('participantName')}
                  className="
                      mx-auto mt-4
                      py-4 px-16
                      font-semibold
                      rounded-lg border hover:border-gray-900
                      shadow-md bg-gray-900 hover:bg-gray-500
                      text-white
                      hover:cursor-pointer focus:outline-none
                      disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      )
    }
  }, [
    props.gameState,
    props.captions,
    props.playerCaption?.Caption,
    props.captionInput,
    captionSubmitted,
    handleSetCaptionInput,
    props.gameParticipants,
    loadTeamCaptions,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (getJudgeName(props.gameState?.JudgeID, props.gameState, props.gameParticipants) ===
      localStorage.getItem('participantName')) {
      setError("The judge cannot submit a caption.")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
      return
    }

    if (props.gameState.PhotoCardID === "") {
      setError("There was an error saving your caption.  Please try again.")
      return
    }

    try {
      handleCaptionCreate(
        localStorage.getItem('participantName'),
        props.gameState.PhotoCardID,
        props.captionInput,
      )
    } catch (e) {
      console.log("Error adding player caption", e);
      setError("There was an error saving your caption.  Please try again.")
      setTimeout(() => {
        setError(null)
      }, 5000);

      setCaptionSubmitted(true)
    }
  };

  return (
    <>
      <div className="mt-[8%] mx-5 border border-black rounded-xl grid place-items-center">
        <div className="p-[2%]">
          <h1 className="text-4xl font-bold text-center text-black">Each team: enter a caption below</h1>
        </div>
        <div className="relative bg-gradient-to-r rounded-full p-8 m-0 bg-black text-white border border-white text-2xl font-bold text-center">{countdownSecond}</div>

        <div className="mt-[3%]">
          <h3 className="text-gray-950 text-lg">Current Judge:  <span className="font-bold">{getJudgeName(props.gameState.JudgeID, props.gameState, props.gameParticipants)}</span></h3>
        </div>
        {loadCaptionMetaSection()}
      </div>

      <div className="text-xl text-red-900 mr-10">{error}</div>

      {loadCaptionSection()}

    </>
  )
}

export default Phase4;
